import {Wisetack} from "../models/wisetack.model";
import {getApiUrl} from "../utils/util-functions";

export const getWisetackPromoTextAsync = async (isPreviewMode: boolean = false, customTotal: number = -1) => {
    if (isPreviewMode) {
        return new Promise<Wisetack>((resolve) => {
            return {} as Wisetack;
        });
    }

    let url = getApiUrl() + '/wisetack/promo/text';

    if (customTotal !== 1) {
        url += '?custom_price=' + customTotal;
    }

    return fetch(url)
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'] as Wisetack;
        });
};


export const getWisetackPromoLinkAsync = async (isPreviewMode: boolean = false, customTotal: number = -1) => {
    if (isPreviewMode) {
        return new Promise<Wisetack>((resolve) => {
            return {} as Wisetack;
        });
    }

    let url = getApiUrl() + '/wisetack/promo/link';

    if (customTotal !== 1) {
        url += '?custom_price=' + customTotal;
    }

    return fetch(url)
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'] as Wisetack;
        });
};
